import React, { useState, createContext, useContext, Dispatch, SetStateAction } from 'react';
import { Cheque } from '@baemingo/table-events/dist/types';

interface ContextType {
  selectedCheque: Cheque | null;
  setSelectedCheque: Dispatch<SetStateAction<Cheque | null>>;
}

interface ProviderProps {
  children: React.ReactNode;
  initialCheque?: Cheque | null;
}

export interface MockedChequeContextProps {
  selectedCheque: Cheque | null;
}

const Context = createContext<ContextType>({} as ContextType);

export const useChequeContext = () => {
  const value = useContext(Context);

  if (!value.setSelectedCheque) {
    throw new Error('Missing Provider for ChequeContext');
  }

  return value;
};

export default function ChequeContextProvider({ children, initialCheque }: ProviderProps) {
  const [selectedCheque, setSelectedCheque] = useState<Cheque | null>(initialCheque || null);

  const contextValue = {
    selectedCheque,
    setSelectedCheque,
  };

  return <Context.Provider value={contextValue}>{children}</Context.Provider>;
}
